import { styled } from '@mui/material/styles';
import {
    Grid,
} from '@mui/material';

export const Chart = styled(Grid)`
  padding: 5%;
`;

export const LateralPanelContainer = styled(Grid)`
  @media screen and (min-width: 960px) {
    height: fit-content;
    margin: 16px;
  }
`;

export const ToggleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '162px',
  height: '32px', 
  backgroundColor: '#212121',
  borderRadius: '100px',
  border: '1px solid #C4C4C4',
  overflow: 'hidden',

  [theme.breakpoints.down('sm')]: {
    width: '140px', 
  },
}));

export const ToggleButton = styled('button')(({ isActive, theme }) => ({
  border: 'none',
  padding: 0,
  fontFamily: 'inherit',
  cursor: 'pointer',
  
  width: isActive ? '115px' : '47px',

  [theme.breakpoints.down('sm')]: {
    width: isActive ? '95px' : '45px',
  },

  
  backgroundColor: isActive ? '#DBC7B8' : 'transparent',
  color: isActive ? '#212121' : '#DBC7B8',
  transition: 'width 0.35s cubic-bezier(0.65, 0, 0.35, 1), background-color 0.35s, color 0.35s',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: isActive ? '8px' : 0,
  borderRadius: '100px',
  
  '& .MuiSvgIcon-root': {
    color: 'inherit',
    fontSize: '20px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
  },

  '& span': {
    fontSize: '14px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    display: isActive ? 'inline' : 'none',
    opacity: isActive ? 1 : 0,
    transition: 'opacity 0.2s linear 0.1s', 
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
}));

export const PanelLoadingContainer = styled(Grid)`
    justify-content: center;
    padding-top: 10px;
`
export const Container = styled(Grid)`
  justify-content: space-evenly;
  @media screen and (max-width: 600px) {
    justify-content: initial;
  }
`
export const ResponsiveCenteredGridItem = styled(Grid)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;